var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 768,
    viewBox: "0 0 1440 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1336.62 728.323C1330.87 728.323 1327.25 722.124 1330.07 717.112L1347.5 686.28C1411.92 561.85 1361.17 374.407 1234.14 310.411C1226.45 306.545 1203.54 297.134 1208.69 314.176C1209.51 316.917 1240.81 344.291 1246.27 350.572C1344.84 463.811 1308.49 651.869 1168.64 711.158C1002.72 781.496 940.264 766.703 713.607 766.703C556.675 766.703 151.009 686.28 -28 717.112C-28 717.112 -28 725.292 -28 597.424C-28 469.557 -20.9625 -4.73625 -28 -28.9186C266.085 -29.0007 994.906 -28.9177 1153.29 -29L1437.95 -28.9182C1454.54 -28.9182 1468 -15.4563 1468 1.13581V698.29C1468 714.882 1454.54 728.344 1437.95 728.344H1336.64L1336.62 728.323Z",
    fill: "#E3EAE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.b530176aea32d8a6760320dfb91656d8.svg";
export { ForwardRef as ReactComponent };